var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#55bbac;stroke-width:2px;stroke-linecap:round}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1413",
    transform: "rotate(180 243 314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    transform: "translate(16929.359 1715.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    d: "M-16464.879-1112.01l2.738 2.739 2.74 2.739",
    className: "cls-1",
    transform: "translate(0 6.244)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    d: "M-16459.4-1112.01l-2.738 2.739-2.738 2.739",
    className: "cls-1",
    transform: "translate(5.558 6.244)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_31",
    fill: "none",
    stroke: "#55bbac",
    strokeWidth: "2px",
    transform: "translate(454 596)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamArrowUp);
export default __webpack_public_path__ + "static/media/team_arrow_up.16f4d2d300d340aee8ce3e9b32d84f60.svg";
export { ForwardRef as ReactComponent };